<div class="grid-x grid-margin-x">

  <div class="cell large-12 margin-right">
    <div class="bold">
      *Document Group:
    </div>
    <div>
      @if (documentGroups.length !== 1) {
        <ng-select [(ngModel)]="internalSelectedDocumentGroup" [items]="documentGroups" bindLabel="name" placeholder=""
        (change)="docGroupSelected($event)"></ng-select>
      }
    </div>
    <div>
      <text-loader [run]="documentGroups.length === 1" [text]="'Loading Document Groups'" [tickType]="'.'" [interval]="2000"></text-loader>
    </div>
  </div>
  <div class="cell large-12">
    <div class="bold">
      *Document Type:
    </div>
    @if (!loadingDocTypes) {
      <ng-select [(ngModel)]="internalSelectedDocumentType" [items]="filteredDocTypes()" bindLabel="name" placeholder=""
      (change)="docTypeSelected($event)"></ng-select>
    }
    @if ((!internalSelectedDocumentType || internalSelectedDocumentType.id == -1) && !loadingDocTypes) {
      <div class="error-container">
        @if (!validDocumentTypeSelected()) {
          <small class="error">
            Please select a valid document group and type.
          </small>
        }
      </div>
    }
    <text-loader [run]="loadingDocTypes" [text]="'Loading Document Types'" [tickType]="'.'" [interval]="2000"></text-loader>
  </div>

</div>